<template>
    <Translations>
        <Theme class="app-scaffold" id="clear-message-verification">
            <v-style>body {overflow: hidden;}</v-style>
            <CguModal v-if="isCguModalVisible"></CguModal>

            <AppHeader></AppHeader>
            <main id="main" :class="{ grid }"><slot></slot></main>

            <AppFooter></AppFooter>
        </Theme>
    </Translations>
</template>

<script>
import CguModal from "@/components/CguModal/CguModal";
import { mapGetters } from "vuex";
import Theme from "@/plano/components/theme";
import Translations from "@/plano/components/translations";
import AppHeader from "@/components/header/Header.vue";
import AppFooter from "@/components/footer/Footer.vue";

export default {
    components: { AppHeader, CguModal, Theme, Translations, AppFooter },
    computed: {
        ...mapGetters("cguStore", {
            isCguModalVisible: "getShown"
        })
    },
    props: {
        grid: Boolean,
        plano: {
            type: Object,
            required: false
        }
    }
};
</script>
<style lang="scss">
@import "./assets/css/themes";

#main {
    flex-grow: 1;
    flex: 1 1 auto;
    overflow-y: scroll;
    @extend %second-text;

    &:not(.grid) {
        display: flex;
        flex-direction: column;
        //overflow: auto;
    }

    &.grid {
        //overflow-y: auto;
        display: grid;
        grid-template-columns: 1fr 15fr 1fr;
        grid-row-gap: 10px;

        > :first-child {
            margin-top: 20px;
        }
        > :last-child {
            margin-bottom: 20px;
        }

        > * {
            grid-column: 2;
        }
    }

    // global style

    table {
        table-layout: fixed;
        width: 100%;
        border-collapse: collapse;

        tbody {
            tr:nth-of-type(odd) {
                @extend %second-background;
            }
            td {
                padding: 4px 8px;
            }
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: "Oswald", Sans-Serif;
        text-transform: uppercase;
    }
    h2 {
        font-size: 26px;
    }
    h1 {
        font-size: 35px;
    }

    th {
        text-transform: uppercase;
        font-weight: bold;
    }
}

.app-scaffold {
    display: flex;
    height: 100%;
    flex-direction: column;
    flex: 1 1 auto;
    justify-content: stretch;
    background-color: rgb(240, 240, 240);

    > header {
        z-index: 1;
        > div.headerDiv:first-child {
            position: unset;
        }
    }

    > footer#footer {
        flex-grow: unset;
        flex: unset;
    }
}
</style>



// WEBPACK FOOTER //
// app-scaffold.vue?30e5b485